module.exports = __webpack_public_path__ + "assets/a36a9fb6b0cafc2268a916da14ad2f68.png";